export const backendserverurl='https://piadmindaaata-backend.pitech.co.ug'

//https://1-be-pifs01-mta-app1.pitech.co.ug
//127.0.0.1:8000
//138.197.8.179
//http://138.197.8.179:10225/
//1-be-getnetdataaa.ge-network.org
//2-be-med-daaaaaaatataaa02.ug-usmedconsult.com

//host link
//https://n0-c1ty-l1k3-4t.pitech.co.ug/